<template>
  <main>
    <b-form @submit.prevent="onSubmit">
      <b-row class="m-3" :disabled="loadingRequests">
        <b-col cols="12" lg="6" md="6" sm="6" xl="4">
          <b-input
            id="filterRequestedFor"
            v-model="filters.requested_for"
            :disabled="filters.relatedRequests || loadingRequests"
            class="filterInput mt-1"
            placeholder="Requested For"
            type="search"
          ></b-input>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="6" xl="4">
          <b-input
            id="filterRequester"
            v-model="filters.requester"
            :disabled="filters.relatedRequests || loadingRequests"
            class="filterInput mt-1"
            placeholder="Requested By"
            type="search"
          ></b-input>
        </b-col>
        <b-col cols="12" lg="12" md="12" sm="12" xl="4">
          <b-form-checkbox
            id="relatedRelatedRequests"
            v-model="filters.relatedRequests"
            :disabled="filters.relatedRequests || loadingRequests"
            class="text-right mt-3"
            name="relatedRequests"
            @change="showOnlyRelatedRequests"
          >
            Show only requests related to me
          </b-form-checkbox>
        </b-col>
      </b-row>

      <hr class="solid mx-3" />

      <b-row class="m-3">
        <b-col cols="12" lg="4" md="6" sm="6" xl="2">
          <b-input
            id="filterStudy"
            v-model="filters.study"
            class="filterInput mt-1"
            placeholder="Study ID"
            :disabled="loadingRequests"
            type="search"
          ></b-input>
        </b-col>
        <b-col cols="12" lg="4" md="6" sm="6" xl="2">
          <b-input
            id="filterSite"
            v-model="filters.site"
            class="filterInput mt-1"
            placeholder="Site #"
            :disabled="loadingRequests"
            type="search"
          ></b-input>
        </b-col>
        <b-col cols="12" lg="4" md="6" sm="6" xl="2">
          <b-form-select
            id="filterApplication"
            v-model="filters.application"
            :disabled="loadingApps || loadingRequests"
            :options="applicationOptions"
            class="filterInput mt-1"
          >
            <template #first>
              <b-form-select-option :disabled="filters.application === null" :value="null"
                >{{ filters.application === null ? 'Application' : '-- Clear --' }}
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col class="px-0 text-right" cols="12" lg="12" md="12" sm="12" xl="6">
          <b-button
            class="buttonStyle pr-4 pl-4 mt-3"
            pill
            type="submit"
            variant="primary"
            :disabled="loadingRequests"
            >Filter
          </b-button>
          <b-button
            class="buttonStyle mt-3"
            pill
            variant="danger"
            @click="clear()"
            :disabled="loadingRequests"
            >Clear</b-button
          >
          <b-button
            class="buttonStyle mt-3"
            pill
            variant="success"
            @click="exportToExcel()"
            :disabled="loadingRequests"
            >Export To Excel</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </main>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'view-all-requests-filters',
    props: {
      requests: Array,
      loadingRequests: Boolean,
    },
    data() {
      return {
        stopSubmit: false,
        filters: {
          requested_for: null,
          requester: null,
          relatedRequests: false,
          study: null,
          site: null,
          application: null,
          status: null,
        },
        requestStatusesOptions: [
          'SUBMITTED',
          'PENDING',
          'IN PROGRESS',
          'TRAINING NOT COMPLETED',
          'VERIFIED',
          'APPROVED',
          'NOT AVAILABLE YET',
          'SENT FOR PROVISIONING',
          'EXPIRED',
          'CLOSED',
          'COMPLETED',
        ],
        loadingApps: false,
        applicationOptions: [],
      };
    },
    created() {
      this.getApplications();
    },
    methods: {
      async getApplications() {
        try {
          this.loadingApps = true;
          let response = await axios.get(`/api/get-access-request-applications`);
          if (response.status !== 204) {
            this.applicationOptions = response.data['items'].map(element => {
              return { name: element.name, id: element.id, value: element.id, text: element.name };
            });
          }
        } catch (error) {
          console.error(error);
        }
        this.loadingApps = false;
      },
      onSubmit() {
        if (!this.stopSubmit) {
          this.$emit('search', this.filters);
        }
        this.stopSubmit = false;
      },
      clear() {
        this.filters = {
          requested_for: null,
          requester: null,
          relatedRequests: false,
          study: null,
          site: null,
          application: null,
          status: null,
        };
        this.$emit('search', this.filters);
      },
      showOnlyRelatedRequests() {
        this.filters.requested_for = '';
        this.filters.requester = '';
      },
      exportToExcel() {
        let columns = [
          'Request ID',
          'Study ID - Site #',
          'Requested For',
          'Requested By',
          'Application',
          'Application Role',
          'Request Status',
          'Account Status',
          'Last Updated Date',
        ];

        let payload = this.requests.map(e => {
          let requested_for = '';
          if (e.userfirstName && e.userlastName) {
            requested_for = `${e.userfirstName} ${e.userlastName}`;
          }
          let studySite = '';
          if (e.studyID && e.siteNumber) {
            studySite = `${e.studyID} - ${e.siteNumber}`;
          }
          let requested_by = '';
          if (e.requestorFirstName && e.requestorLastName) {
            requested_by = `${e.requestorFirstName} ${e.requestorLastName}`;
          }
          return {
            'Request ID': e.childId ?? '',
            'Study ID - Site #': studySite,
            'Requested For': requested_for ?? '',
            'Requested By': requested_by ?? '',
            Application: e.application ?? '',
            'Application Role': e.systemRole ?? '',
            'Request Status': e.statusMap ?? '',
            'Account Status': e.accountStatus ?? '',
            'Last Updated Date': this.formatDate(e.lastUpdated),
          };
        });

        payload.push({
          fileName: `All Requests`,
          columns: columns,
        });
        this.$store.dispatch('exportExcel', payload);
      },
      formatDate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date)
            .utc()
            .format('DD MMM YYYY h:mm A');
        }
      },
    },
  };
</script>

<style scoped>
  .buttonStyle {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #ffffff;
  }
</style>
